import createTableStore from "ds/components/Table/store/useTableStore";

import {
  TEMPLATE_DEPLOYMENT_STACKS_COLUMN_CONFIG,
  TEMPLATE_DEPLOYMENT_STACKS_COLUMNS_STORAGE_KEY,
} from "./constants";

const useTemplateDeploymentStacksTableStore = createTableStore({
  storageKey: TEMPLATE_DEPLOYMENT_STACKS_COLUMNS_STORAGE_KEY,
  config: TEMPLATE_DEPLOYMENT_STACKS_COLUMN_CONFIG,
});

export default useTemplateDeploymentStacksTableStore;
